import Icons from "assets";
import React from "react";
import { createPortal } from "react-dom";
import { twMerge } from "tailwind-merge";

export type TableLoaderProps = {
  isLoading: boolean;
  fullScreen?: boolean;
  customClass?: string;
};

export const TableLoader: React.FC<TableLoaderProps> = ({
  isLoading,
  fullScreen = false,
  customClass = "bg-transparent",
}) => {
  if (!isLoading) return null;

  const loader = (
    <div
      className={twMerge(
        "absolute inset-0 flex items-center justify-center",
        fullScreen ? "z-50 bg-white" : "bg-transparent",
        customClass,
      )}>
      <div className="flex flex-col items-center">
        <Icons.Loader customClass="animate-spin size-8" />
        <p className="mt-2 text-sm text-gray-600">Loading...</p>
      </div>
    </div>
  );

  if (!fullScreen || typeof document === "undefined") {
    return loader;
  }

  const host =
    document.querySelector('[data-testid="app-content-area"]') ??
    document.querySelector('[data-testid="content-wrapper"]');

  return host ? createPortal(loader, host) : loader;
};
